import dynamic from 'next/dynamic';
import { SummaryOfChargesProps } from './SummaryOfCharges.types';

export const SummaryOfChargesR0 = dynamic<SummaryOfChargesProps>(() =>
 import('./SummaryOfCharges')
);

